import type { SvgIconComponent } from "@mui/icons-material";
import BalanceIcon from "@mui/icons-material/Balance";
import CampaignIcon from "@mui/icons-material/Campaign";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import JoinInnerIcon from "@mui/icons-material/JoinInner";
import SportsKabaddiIcon from "@mui/icons-material/SportsKabaddi";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import { TypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/types";
import type { IGetEventsAggregatedRequestParams } from "~/feature/dashboard/types";

export const TYPE_FILTER_ALL_VALUE = "all";

export const emptyTypeFilterRequestParams: IGetEventsAggregatedRequestParams = {
  oneMarket: undefined,
  hasDisputedMarkets: undefined,
  minEventCount: undefined,
  hasBreakingMarket: undefined,
  hasTrendingMarket: undefined,
};

export const requestParamsByTypeFilterType: Record<
  TypeFilterEnum,
  IGetEventsAggregatedRequestParams
> = {
  [TypeFilterEnum.Binary]: {
    ...emptyTypeFilterRequestParams,
    oneMarket: true,
  },
  [TypeFilterEnum.MultiOutcome]: {
    ...emptyTypeFilterRequestParams,
    oneMarket: false,
  },
  [TypeFilterEnum.Breaking]: {
    ...emptyTypeFilterRequestParams,
    hasBreakingMarket: true,
  },
  [TypeFilterEnum.Trending]: {
    ...emptyTypeFilterRequestParams,
    hasTrendingMarket: true,
  },
  [TypeFilterEnum.UMADisputed]: {
    ...emptyTypeFilterRequestParams,
    hasDisputedMarkets: true,
  },
  [TypeFilterEnum.Aggregated]: {
    ...emptyTypeFilterRequestParams,
    minEventCount: 2,
  },
};

export const labelByTypeFilterEnum: Record<TypeFilterEnum, string> = {
  [TypeFilterEnum.Binary]: "50:50",
  [TypeFilterEnum.MultiOutcome]: "Multi-Outcome",
  [TypeFilterEnum.Breaking]: "Breaking",
  [TypeFilterEnum.Trending]: "Trending",
  [TypeFilterEnum.UMADisputed]: "UMA (Disputed)",
  [TypeFilterEnum.Aggregated]: "Aggregated Events",
};

export const iconByTypeFilterEnum: Record<TypeFilterEnum, SvgIconComponent> = {
  [TypeFilterEnum.Binary]: BalanceIcon,
  [TypeFilterEnum.MultiOutcome]: DynamicFeedIcon,
  [TypeFilterEnum.Breaking]: CampaignIcon,
  [TypeFilterEnum.Trending]: TrendingUpIcon,
  [TypeFilterEnum.UMADisputed]: SportsKabaddiIcon,
  [TypeFilterEnum.Aggregated]: JoinInnerIcon,
};
